import {connect} from 'react-redux';
import {NotebookExpDesignWeb as Component} from './NotebookExpDesignWeb';
import {setChapter, startTour} from '@learningblocks/exp-redux';
import {setCollapse} from '@learningblocks/exp-redux';
import {
  getTitle,
  getMenuList,
  getCurrentMenu,
  getDescription,
  getNextMenuValue,
  getDrawerCollapsed,
  getCurrentChapterComponents,
  getCurrentChapterFromMenu,
} from './NotebookExpDesignWeb.selector';

function mapStateToProps(state) {
  return {
    drawerCollapsed: getDrawerCollapsed(state),
    components: getCurrentChapterFromMenu(state),
    menuList: getMenuList(state),
    currentMenu: getCurrentMenu(state),
    nextMenuValue: getNextMenuValue(state),
    title: getTitle(state),
    description: getDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetChapter: (params) => {
      dispatch(setChapter(params));
    },
    onSetCollapse: (params) => {
      dispatch(setCollapse(params));
    },
    startTour: (params) => {
      dispatch(startTour());
    },
  };
}

export const NotebookExpDesignWebNew = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
